import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Fade, IconButton, Tooltip } from "@mui/material";
import "./ContinueAutoDial.css";
import { stateAction } from "../Store/Actions/AuthAction";

import {
  GET_NEXT_ASSIGNMENT,
  SET_AUTO_DIAL,
  SET_AUTO_DIAL_CAMPAIGN,
  SET_AUTO_DIAL_PAUSED,
  SET_LAST_ASSIGNMENTID,
} from "../Store/Types/AgentTypes";

export default function ContinueAutoDial({ changePage }) {
  const dispatch = useDispatch();
  const { isAutoDialPaused } = useSelector((state) => state.agent);
  const { isInCall } = useSelector((state) => state.call);

  return (
    <Fade appear in={!isInCall && isAutoDialPaused} timeout={500} unmountOnExit>
      <div className="continueAutoDial">
        <div className="continueAutoDial_content">
          <Tooltip title="Stop autodial" arrow>
            <IconButton
              sx={{
                width: 39,
                height: 39,
                bgcolor: "#F97427",
                color: "#FFF",
                boxShadow: "0px 2px 18px 1px rgba(0, 0, 0, 0.18)",
                "&:hover": { backgroundColor: "#CC6325" },
              }}
              onClick={() => {
                dispatch({ type: SET_AUTO_DIAL, payload: false });

                dispatch({
                  type: SET_LAST_ASSIGNMENTID,
                  payload: null,
                });

                dispatch({
                  type: SET_AUTO_DIAL_CAMPAIGN,
                  payload: {},
                });

                dispatch(
                  stateAction("READY", undefined, "AUX - REST", "Green")
                );

                if (localStorage.getItem("winPage") !== "campaign") {
                  changePage("campaign");
                }

                toast.info("Autodial has stopped.", {
                  autoClose: 3000,
                });

                dispatch({
                  type: SET_AUTO_DIAL_PAUSED,
                  payload: false,
                });
              }}
            >
              <Icon height="26" icon="zondicons:hand-stop" />
            </IconButton>
          </Tooltip>

          <p>Auto-dial Action</p>

          <Tooltip title="Continue autodial" arrow>
            <IconButton
              sx={{
                width: 39,
                height: 39,
                bgcolor: "#0343C7",
                color: "#FFF",
                boxShadow: "0px 2px 18px 1px rgba(0, 0, 0, 0.18)",
                "&:hover": { backgroundColor: "#063493" },
              }}
              onClick={() => {
                dispatch({
                  type: SET_AUTO_DIAL_PAUSED,
                  payload: false,
                });

                dispatch(
                  stateAction("READY", undefined, "AUX - REST", "Green")
                );

                if (localStorage.getItem("winPage") !== "campaign") {
                  changePage("campaign");
                } else {
                  dispatch({ type: GET_NEXT_ASSIGNMENT });
                }
              }}
            >
              <Icon height="26" icon="iconoir:play-solid" />
            </IconButton>
          </Tooltip>
        </div>

        <div className="continueAutoDial_rightSpace" />
      </div>
    </Fade>
  );
}
